module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Call#1-3866dad316843193e811b76cd09c596e.svg";